import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { fg } from '@atlaskit/platform-feature-flags';

import type { RemixModalMetadata } from '../types';

export type MalleableUiPluginState = {
	isRemixModalOpen: boolean;
	remixModalMetadata?: RemixModalMetadata;
	remixSource?: string;
	showLocationPicker: boolean;
};

export type MalleableUiPluginMeta = {
	isRemixModalOpen?: boolean;
	remixModalMetadata?: RemixModalMetadata;
	remixSource?: string;
	showLocationPicker?: boolean;
};

export const malleableUiPluginKey: PluginKey<MalleableUiPluginState> =
	new PluginKey<MalleableUiPluginState>('malleableUiPlugin');

export function createMalleableUiPmPlugin(dispatch: Dispatch): SafePlugin {
	return new SafePlugin({
		key: malleableUiPluginKey,
		state: {
			init(): MalleableUiPluginState {
				return {
					isRemixModalOpen: false,
					remixModalMetadata: undefined,
					showLocationPicker: false,
				};
			},
			apply(tr, pluginState): MalleableUiPluginState {
				const meta: MalleableUiPluginMeta | undefined = tr.getMeta(malleableUiPluginKey);

				if (meta && meta.isRemixModalOpen !== undefined) {
					const result: MalleableUiPluginState = {
						isRemixModalOpen: meta.isRemixModalOpen,
						remixModalMetadata: meta.remixModalMetadata,
						remixSource: meta.remixSource,
						showLocationPicker: false,
					};
					dispatch(malleableUiPluginKey, result);
					return result;
				}

				if (
					meta &&
					meta.showLocationPicker !== undefined &&
					fg('platform_editor_ai_remix_in_editor_loading')
				) {
					const result: MalleableUiPluginState = {
						...pluginState,
						showLocationPicker: meta.showLocationPicker,
					};
					dispatch(malleableUiPluginKey, result);
					return result;
				}

				return pluginState;
			},
		},
	});
}
